import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Box } from "@mui/material";
import DropComponent from "./DropComponent";
import { addRelation } from "../../../../slices/query";
export default function RelationShip() {
  const relations = useSelector((state) => state.query.relationFields);
  const lastRelation = relations[relations.length - 1];
  const dispatch = useDispatch();

  const handleClickAdd = (event) => {
    //     if(validateLastRelation())
    dispatch(addRelation());
  };

  const validateLastRelation = () => {
    const { LTable, LFields, RTable, RFields } = lastRelation;
    return LTable.length && LFields.length && RTable.length && RFields.length;
  };

  return (
    <Box sx={{ height: "100%", overflowY: "auto" }}>
      <DropComponent />
      <Button onClick={handleClickAdd}>Add RelationShip</Button>
    </Box>
  );
}
